import { BaseModelDTO } from './baseModelDTO';

export class BasicBonModelDTO extends BaseModelDTO {
    public modifie: boolean; // a vérifié
    public aPayer: boolean; // a vérifié
    public facture: boolean;
    public annule: boolean;
    public livre: boolean;
    public refMaint: string; // a verifié
    public ae: string; // a vérifié
    public dAnnule?: Date;
    public dProvis?: Date;
    public dDeprovis?: Date;
}

